export default {
  tags: {
    default: 'Implicit',
    visible_to: 'Vizibil pentru',
    not_visible_to: 'Invizibil pentru',
  },
  labels: {
    inclusive: 'Inclus',
    exclusive: 'Exclus',
    public: 'Public',
  },
  buttons: {
    edit: 'Editează',
    delete: 'Șterge',
  },
};
